module.exports = __webpack_public_path__ + "static/media/paid.a2d09a4a.svg";